import React from "react";
import { Header } from "../../../shared/compoments";
import ProprieteDatatable from "./ProprieteDatatable";
function DetailBiensProprietaire({ items, setShowDetailBien, nameOfOwner }) {
  return (
    <div>
      <Header
        libelle={`les Biens de ${" "} ${nameOfOwner}`}
        isReturn
        backWithVariable
        setShowDetailBien={setShowDetailBien}
      />
      <ProprieteDatatable items={items} itemsForFilter={[]} filters={{}} />
    </div>
  );
}

export default DetailBiensProprietaire;
